import React from "react";

interface CardTitleProps {
    children: React.ReactNode;
    options?: React.ReactNode;
}

export const CardTitle: React.FC<CardTitleProps> = ({ children, options }) => {
    return (
        <div className="gs-list-page-card-header">
            <div className="gs-list-page-header">
                <div className="gs-list-page-title-wrap">{children}</div>
                {options && <div className="gs-list-page-tools">{options}</div>}
            </div>
        </div>
    );
};
